function repeatEvery(func: () => void, interval: number) {
  function start() {
    func();
    setInterval(func, interval);
  }

  start();
}

export default repeatEvery;
